import { Repository } from "src/firebase/firestore/repository";
import { NotificationHealth } from "./types/notification-health.entity";

class NotificationHealthRepository extends Repository<NotificationHealth> {
  constructor() {
    super("notification_health");
  }
}

export const notificationHealthRepository = new NotificationHealthRepository();
